import { useDispatch } from 'react-redux'
import ExportButton from '../../common/ExportButton'
import { fundrasingExportColumns } from '../../config/exportColumns/fundrasingExportColumns'
import { appAllGetFundrasing } from '../../store/fundrasing'
import TableFilter from './tableFilter'

function ApnaMandalPortal() {
	const dispatch = useDispatch()

	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Apna mandal</div>
					<div>
						<ExportButton
							fetchAction={params =>
								dispatch(
									appAllGetFundrasing({
										...params,
										paidtoportal: true,
										loading: false,
									}),
								)
							}
							columns={fundrasingExportColumns}
							fileName="Fundraising_Paid_To_Portal"
							sheetName="Fundraising"
							buttonText="Export Portal Contribution "
						/>
					</div>
				</div>
				<TableFilter />
			</div>
		</>
	)
}

export default ApnaMandalPortal
